<template>
  <div id="app">
    <!--<router-view />-->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<style>
.page-title {
  color: #0288D1;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #212121;
  border-color: #0288D1;
  padding-bottom: 8px;
  margin-bottom: 10px;
}
i.btn {
  margin-right: 8px;
}
.div-input--small {
  border: 1px solid #e4e7ed;
  padding: 0 15px;
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  background-color: #f5f7fa;
}
</style>

<script>
export default {
  provide() { // 注册一个方法
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
        console.log('reload')
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue